/** org: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "revokeQ": "Revoke the invitation for {email}?",
  "leaveQ": "Leave {org}?",
  "removeQ": "Remove {name} ({email}) from {org}?",
  "planLine": "{plan} · {used} / {seats} players",
  "trialEndsIn": "Trial ends in {n} day | Trial ends in {n} days",
  "daysLeft": "{n} day left in your trial. | {n} days left in your trial.",
  "seatsUsed": "{used} / {seats} used",
  "pricing": "Standard {std} · Advanced {adv} per player / month",
  "editRoleOf": "Edit role of {name}",
  "removeX": "Remove {name}",
  "nMembers": "{n} member | {n} members",
  "revokeFor": "Revoke invitation for {email}",
  "roleOf": "Role · {name}",
  "shareLink": "Share this one-time link with",
  "expires7": "(expires in 7 days):",
  "plan_TRIAL": "14-day free trial",
  "plan_STANDARD": "Standard",
  "plan_ADVANCED": "Advanced",
  "tabAccount": "Account Settings",
  "tabSecurity": "Account Security",
  "tabOrg": "Organization",
  "tabSubscription": "Subscription",
  "tabPlayers": "Default Player Settings",
  "tabUsers": "Users",
  "secSchedule": "Working Schedule",
  "secDisplay": "Display",
  "secSound": "Sound",
  "secMonitoring": "Monitoring",
  "renamed": "Organization renamed",
  "countryCleared": "Country cleared",
  "countrySaved": "Country saved · maps open there",
  "defaultsSaved": "Player defaults saved · players update on their next sync",
  "helpOwner": "Full control, including billing and owners",
  "helpAdmin": "Manage members, invitations and players",
  "helpEditor": "Manage content and schedules",
  "helpViewer": "Read-only access",
  "colMember": "Member",
  "colRole": "Role",
  "colJoined": "Joined",
  "colEmail": "Email",
  "colInvitedBy": "Invited by",
  "colExpires": "Expires",
  "settings": "Settings",
  "invitePaused": "Inviting is paused until you choose a plan",
  "inviteMember": "Invite member",
  "orgSettings": "Organization settings",
  "trialEnded": "Trial ended",
  "orgName": "Organization name",
  "save": "Save",
  "saving": "Saving…",
  "country": "Country",
  "countryHint": "Maps open on this country when there is nothing to show yet, and place search prefers it.",
  "notSet": "Not set",
  "plan": "Plan",
  "trialOver": "Your trial has ended. Existing screens keep playing; adding screens and inviting users is paused.",
  "seats": "Player seats",
  "members": "Members",
  "storage": "Storage",
  "monthly": "Estimated monthly",
  "playerDefaults": "Player defaults",
  "defaultsHint": "Every player uses these unless its own Player Settings override a field. Saving updates every player.",
  "you": "(you)",
  "editRole": "Edit role",
  "leaveOrg": "Leave organization",
  "removeMember": "Remove member",
  "pending": "Pending invitations",
  "revokeInvite": "Revoke invitation",
  "noPending": "No pending invitations.",
  "accessIncluded": "User access management is included in every plan.",
  "email": "Email",
  "role": "Role",
  "inviteLink": "Invitation link",
  "copied": "Copied",
  "copy": "Copy",
  "inviteAnother": "You can invite someone else right away.",
  "current": "(current)",
  "immediate": "Takes effect immediately, including in their open browser tabs.",
  "access": "Player access",
  "accessAll": "Every player",
  "accessSome": "Only the players in these groups",
  "accessSomeHint": "They see, publish to and manage only these groups' players. Tags, regions, alerts, reports and billing stay closed to them. The content library is shared.",
  "noGroupsYet": "No player groups yet.",
  "accessLimited": "Limited to {n} group | Limited to {n} groups",
  "removeFromOrg": "Remove from organization",
  "loseAccess": "They lose access at once; their content stays.",
  "cancel": "Cancel",
  "done": "Done",
  "createInvite": "Create invitation",
  "creating": "Creating…",
  "saveRole": "Save role"
};
const ar: typeof en = {
  "revokeQ": "إلغاء الدعوة الموجّهة إلى {email}؟",
  "leaveQ": "مغادرة {org}؟",
  "removeQ": "إزالة {name} ({email}) من {org}؟",
  "planLine": "{plan} · {used} / {seats} مشغلات",
  "trialEndsIn": "تنتهي الفترة التجريبية اليوم | تنتهي الفترة التجريبية خلال يوم واحد | تنتهي الفترة التجريبية خلال يومين | تنتهي الفترة التجريبية خلال {n} أيام | تنتهي الفترة التجريبية خلال {n} يومًا | تنتهي الفترة التجريبية خلال {n} يوم",
  "daysLeft": "لم يبقَ شيء من فترتك التجريبية. | بقي يوم واحد في فترتك التجريبية. | بقي يومان في فترتك التجريبية. | بقيت {n} أيام في فترتك التجريبية. | بقي {n} يومًا في فترتك التجريبية. | بقي {n} يوم في فترتك التجريبية.",
  "seatsUsed": "{used} / {seats} مستخدمة",
  "pricing": "القياسية {std} · المتقدمة {adv} لكل مشغل / شهريًا",
  "editRoleOf": "تعديل دور {name}",
  "removeX": "إزالة {name}",
  "nMembers": "لا أعضاء | عضو واحد | عضوان | {n} أعضاء | {n} عضوًا | {n} عضو",
  "revokeFor": "إلغاء الدعوة الموجّهة إلى {email}",
  "roleOf": "الدور · {name}",
  "shareLink": "شارك هذا الرابط لمرة واحدة مع",
  "expires7": "(ينتهي خلال ٧ أيام):",
  "plan_TRIAL": "تجربة مجانية لمدة ١٤ يومًا",
  "plan_STANDARD": "القياسية",
  "plan_ADVANCED": "المتقدمة",
  "tabAccount": "إعدادات الحساب",
  "tabSecurity": "أمان الحساب",
  "tabOrg": "المؤسسة",
  "tabSubscription": "الاشتراك",
  "tabPlayers": "إعدادات المشغل الافتراضية",
  "tabUsers": "المستخدمون",
  "secSchedule": "جدول العمل",
  "secDisplay": "العرض",
  "secSound": "الصوت",
  "secMonitoring": "المراقبة",
  "renamed": "تمت إعادة تسمية المؤسسة",
  "countryCleared": "تم مسح الدولة",
  "countrySaved": "تم حفظ الدولة · تُفتح الخرائط عليها",
  "defaultsSaved": "تم حفظ الإعدادات الافتراضية للمشغلات · تُحدَّث المشغلات عند المزامنة التالية",
  "helpOwner": "تحكم كامل، بما في ذلك الفوترة والمالكين",
  "helpAdmin": "إدارة الأعضاء والدعوات والمشغلات",
  "helpEditor": "إدارة المحتوى والجداول",
  "helpViewer": "وصول للقراءة فقط",
  "colMember": "العضو",
  "colRole": "الدور",
  "colJoined": "تاريخ الانضمام",
  "colEmail": "البريد الإلكتروني",
  "colInvitedBy": "دعاه",
  "colExpires": "تنتهي",
  "settings": "الإعدادات",
  "invitePaused": "الدعوات متوقفة حتى تختار خطة",
  "inviteMember": "دعوة عضو",
  "orgSettings": "إعدادات المؤسسة",
  "trialEnded": "انتهت الفترة التجريبية",
  "orgName": "اسم المؤسسة",
  "save": "حفظ",
  "saving": "جارٍ الحفظ…",
  "country": "الدولة",
  "countryHint": "تُفتح الخرائط على هذه الدولة عندما لا يوجد ما يُعرض بعد، ويفضّلها البحث عن الأماكن.",
  "notSet": "غير محدد",
  "plan": "الخطة",
  "trialOver": "انتهت فترتك التجريبية. تستمر الشاشات الحالية في العرض؛ وإضافة الشاشات ودعوة المستخدمين متوقفة.",
  "seats": "مقاعد المشغلات",
  "members": "الأعضاء",
  "storage": "التخزين",
  "monthly": "التقدير الشهري",
  "playerDefaults": "الإعدادات الافتراضية للمشغلات",
  "defaultsHint": "يستخدم كل مشغل هذه القيم ما لم تتجاوزها إعدادات المشغل الخاصة به. الحفظ يحدّث كل المشغلات.",
  "you": "(أنت)",
  "editRole": "تعديل الدور",
  "leaveOrg": "مغادرة المؤسسة",
  "removeMember": "إزالة العضو",
  "pending": "الدعوات المعلّقة",
  "revokeInvite": "إلغاء الدعوة",
  "noPending": "لا توجد دعوات معلّقة.",
  "accessIncluded": "إدارة وصول المستخدمين مضمّنة في كل خطة.",
  "email": "البريد الإلكتروني",
  "role": "الدور",
  "inviteLink": "رابط الدعوة",
  "copied": "تم النسخ",
  "copy": "نسخ",
  "inviteAnother": "يمكنك دعوة شخص آخر فورًا.",
  "current": "(الحالي)",
  "immediate": "يسري فورًا، بما في ذلك في علامات تبويب المتصفح المفتوحة لديهم.",
  "access": "الوصول إلى المشغّلات",
  "accessAll": "كل المشغّلات",
  "accessSome": "المشغّلات في هذه المجموعات فقط",
  "accessSomeHint": "يرى ويُنشر ويُدير مشغّلات هذه المجموعات فقط. تبقى الوسوم والمناطق والتنبيهات والتقارير والفوترة مغلقة أمامه. مكتبة المحتوى مشتركة.",
  "noGroupsYet": "لا توجد مجموعات مشغّلات بعد.",
  "accessLimited": "مقيّد بمجموعة واحدة | مقيّد بـ {n} مجموعات",
  "removeFromOrg": "إزالة من المؤسسة",
  "loseAccess": "يفقد الوصول فورًا؛ ويبقى محتواه.",
  "cancel": "إلغاء",
  "done": "تم",
  "createInvite": "إنشاء دعوة",
  "creating": "جارٍ الإنشاء…",
  "saveRole": "حفظ الدور"
};
export default { en, ar };
